module.exports = function() {
  return new Worker(__webpack_public_path__ + "4c9029ba18603b924ede.worker.js");
};